export default "//static.tradera.net/touchweb/static/output/images/category-jewlry-gemstones.f8ac5f7f.svg";